import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const MotionBox = motion(Box);

const Home = () => {
  const navigate = useNavigate();

  const navigateToIndex = () => {
    navigate('/index');
  };

  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
      textAlign="center"
      p={5}
      mt={20}
      mx="auto"
      maxW="lg"
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      bg="gray.700"
      color="white"
    >
      <Text fontSize="5xl" fontFamily="Cinzel" letterSpacing="wide">
        Eldritch Web
      </Text>
      <Text fontSize="xl" mt={4} mb={8}>
        Dare to explore the cosmic horrors and uncover the secrets of the unknown.
      </Text>
      <Button
        onClick={navigateToIndex}
        size="lg"
        colorScheme="purple"
        variant="outline"
      >
        Begin the Descent
      </Button>
    </MotionBox>
  );
};

export default Home;
